import { SearchBar } from '../../shared';

interface ParticipantSearchBarProps {
  onSearchChange: (query: string) => void;
}

export const ParticipantSearchBar: React.FC<ParticipantSearchBarProps> = ({
  onSearchChange,
}) => {
  return (
    <div style={{ flex: 1, minWidth: 0 }}>
      <SearchBar
        onSearchChange={onSearchChange}
        placeholder="Search participants..."
        width="100%"
        dataTarget="participants-search-input"
      />
    </div>
  );
};
